import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Bones } from '../domain';
import { SkeletonBlockComponent } from '../ui-skeleton-block/skeleton-block.component';
import { SkeletonGridComponent } from '../ui-skeleton-grid/skeleton-grid.component';

@Component({
  selector: 'rma-skeleton-card',
  template: `
    <div class="flex h-6 gap-4">
      @if (headerIcon) {
        <rma-skeleton-block class="h-full w-6" />
      }
      <rma-skeleton-block class="h-full w-2/3" />
    </div>
    @if (subText) {
      <rma-skeleton-block class="mt-4 h-6 w-2/3" />
    }
    <rma-skeleton-grid class="mt-4 block" [bones]="bones" heightClass="h-28" />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SkeletonBlockComponent, SkeletonGridComponent],
})
export class SkeletonCardComponent {
  @Input()
  headerIcon = true;

  @Input()
  subText = true;

  @Input()
  bones: Bones = 3;
}
